import $ from 'jquery';

const Accordion = {
    accordion: function () {
        const $accordionItems = $(".accordion-module__item");

        $accordionItems.each(function () {
            const $item = $(this);
            const $title = $item.find(".accordion-module__title");
            const $description = $item.find(".accordion-module__description");

            $description.css({
                maxHeight: "0",
                overflow: "hidden",
            });

            $title.on("click", function () {
                const isOpen = $item.hasClass("is-open");

                if (isOpen) {
                    $description.css("maxHeight", "0");
                    $item.removeClass("is-open");
                } else {
                    $accordionItems.each(function () {
                        const $otherItem = $(this);
                        const $otherDescription = $otherItem.find(".accordion-module__description");
                        $otherDescription.css("maxHeight", "0");
                        $otherItem.removeClass("is-open");
                    });

                    $description.css("maxHeight", $description.prop("scrollHeight") + "px");
                    $item.addClass("is-open");
                }
            });
        });
    },

    init: function () {
        this.accordion();
    },
};

export default Accordion;